export const personalInfo = {
  name: "Joseph Chukwuemeka Ofili",
  title: "Software Engineer",
  subtitle: "AI-Powered Solutions & Cloud Architecture Expert",
  location: "Lagos, Nigeria",
  email: "josephofilii@gmail.com",
  phone: "+2347060942709",
  website: "josephofili.live",

  social: {
    github: "https://www.github.com/jayyy123",
    linkedin: "https://www.linkedin.com/in/joseph-ofili/",
    upwork: "https://www.upwork.com/freelancers/~016333b88d9874e553?viewMode=1",
    resume: "https://docs.google.com/document/d/1jM3xDvYeyvY18k68SBtupCqG0NFv8QemlWpuGIqnnVA/edit?usp=sharing"
  },

  bio: {
    personal: "I'm an avid fan of animes, movies, and DC content. I enjoy TV shows and find relaxation in chess.",
    professional: "Experienced Software Engineer with over 4 years of expertise in building robust, scalable web applications and AI-powered solutions. I specialize in Python, Node.js, React, and AWS cloud services, with a proven track record of integrating advanced AI/ML technologies including LLMs, voice synthesis, and automated systems."
  },

  experience: {
    years: 4,
    totalProjects: "50+",
    companiesWorked: 4,
    technologies: "30+"
  },

  typingTexts: [
    "a Software Engineer",
    "an AI Integration Expert",
    "a Cloud Architecture Expert",
    "a Backend Systems Engineer",
    "a Frontend React Engineer",
    "a Mobile App Developer",
    "an AI Voice Expert",
    "a Fullstack Engineer"
  ]
};

export const workExperience = [
  {
    id: 1,
    company: "ManaknightDigital",
    position: "Fullstack Engineer",
    location: "Ontario, Canada (Remote)",
    duration: "August 2022 – Present",
    type: "Full-time",
    description: "Leading development of scalable web applications and AI-powered platforms, enhancing functionality, user engagement, and operational efficiency across multiple B2B/B2C projects.",
    achievements: [
      "Architected AI-driven calling and voice streaming solutions integrating STT/TTS (Deepgram, ElevenLabs), LLMs (Claude, Groq Llama), and telephony APIs (Twilio, Telnyx)",
      "Implemented intelligent voicemail detection, automated call recording/summarization, and dynamic script management for multi-language support",
      "Led development of Backend-as-a-Service (BaaS) platform and internal developer toolkit (MKD Agent) with AI-assisted code generation from Figma/configs",
      "Developed comprehensive platforms featuring community management, referral tracking, meeting scheduling (Google Calendar, Microsoft Teams, Zoom via OAuth), and complex commission-based payment systems",
      "Built specialized platforms like Courtmatchup (sports facility booking), Coinchord (cryptocurrency payments), and Auth8 (authentication with GraphQL integration)",
      "Managed full software development lifecycle using Git and CI/CD pipelines (Jenkins), achieving 50% reduction in deployment time",
      "Optimized AWS resource utilization (Lambda, EC2, RDS, S3), ensuring 99.9% application uptime and decreasing operational costs by 20%",
      "Authored automated cron jobs and comprehensive unit tests, boosting system reliability by 40%"
    ],
    technologies: ["Python", "Node.js", "React", "AWS", "Docker", "Jenkins", "Stripe", "OpenAI", "Claude", "Groq", "Deepgram", "ElevenLabs", "Twilio", "Telnyx", "Vector Databases", "RAG Systems"]
  },
  {
    id: 2,
    company: "DIMECHEST Limited",
    position: "Fullstack Engineer (Contract)",
    location: "Abuja, Nigeria",
    duration: "June 2023 – August 2023",
    type: "Contract",
    description: "Collaborated in an agile team to develop user-centric interfaces and deploy applications to cloud platforms.",
    achievements: [
      "Improved user satisfaction metrics by 25% through React interface development",
      "Reduced deployment lead time by 20% through Firebase integration",
      "Implemented responsive design patterns for mobile-first approach"
    ],
    technologies: ["React", "Firebase", "JavaScript", "CSS3", "Agile"]
  },
  {
    id: 3,
    company: "Mind-Spa NG",
    position: "Backend Engineer Intern (Node.js)",
    location: "Nigeria",
    duration: "September 2022 – June 2023",
    type: "Internship",
    description: "Developed and tested food delivery service APIs using Node.js and TDD principles, enhancing code quality and reducing bug occurrences.",
    achievements: [
      "Enhanced code quality through comprehensive testing and TDD practices",
      "Improved system reliability and user satisfaction by 20%",
      "Engineered secure authentication and order management endpoints"
    ],
    technologies: ["Node.js", "Express.js", "MongoDB", "TDD", "API Development"]
  },
  {
    id: 4,
    company: "CISRG",
    position: "Data Scientist Intern / Fullstack Engineer Intern",
    location: "Nigeria",
    duration: "November 2021 – September 2022",
    type: "Internship",
    description: "Designed and fine-tuned supervised learning models (Python, Django) for loan repayment and heart-failure predictions, achieving 85% accuracy rate.",
    achievements: [
      "Achieved 85% accuracy rate in loan repayment and heart-failure prediction models",
      "Enhanced data security and accuracy by 30% through robust authentication",
      "Integrated ML models into Django web applications for real-time predictions"
    ],
    technologies: ["Python", "Django", "Machine Learning", "Data Science", "Supervised Learning", "Data Analysis"]
  },
  {
    id: 5,
    company: "Speer",
    position: "AI/ML Engineer Intern",
    location: "Remote",
    duration: "2024",
    type: "Internship",
    description: "Worked on advanced AI/ML projects focusing on computer vision, natural language processing, and automated systems.",
    achievements: [
      "Developed computer vision models for object detection and classification",
      "Implemented NLP pipelines for text processing and analysis",
      "Built automated systems for data collection and processing",
      "Contributed to research projects on AI model optimization"
    ],
    technologies: ["Python", "TensorFlow", "PyTorch", "Computer Vision", "NLP", "Data Processing"]
  }
];

export const skills = {
  languages: [
    "Python", "Node.js", "JavaScript (ES6+)", "TypeScript", "Kotlin", "Golang", "SQL"
  ],
  markup: [
    "HTML5", "CSS3"
  ],
  frameworks: [
    "Express.js", "Flask", "React", "React Native", "Sequelize", "EJS", "Bootstrap", "Tailwind CSS"
  ],
  databases: [
    "MySQL", "PostgreSQL", "MongoDB", "Firebase", "Redis", "Vector Databases"
  ],
  cloud: [
    "AWS (Lambda, EC2, RDS, S3)", "Docker", "Jenkins", "Git", "CI/CD Pipelines", "CapRover", "RunPod"
  ],
  ai: [
    "OpenAI GPT Series", "Claude", "Groq Llama Models", "Gemini", "Prompt Engineering",
    "RAG Systems", "Fine-tuning", "Deepgram", "ElevenLabs", "Whisper", "Voice Cloning",
    "STT/TTS", "Diarization", "AMD", "Speech Recognition", "Computer Vision", "NLP"
  ],
  integrations: [
    "Stripe (Payments, Connect)", "Hubspot CRM", "Authorize.net", "Eukapay", "Google APIs",
    "Microsoft Graph API", "Twilio", "Telnyx", "OAuth", "RESTful APIs", "GraphQL",
    "Google Calendar", "Microsoft Teams", "Zoom API", "Gmail API", "IMAP"
  ],
  tools: [
    "TDD", "Agile Principles", "Postman", "Linux", "Bash Scripting", "Data Scraping",
    "Data Classification", "Supervised Learning", "TensorFlow", "PyTorch"
  ]
};

export const education = {
  degree: "B.S.E in Computer Science and Computer Engineering",
  school: "Obafemi Awolowo University",
  location: "Ile-Ife, Osun State, Nigeria",
  duration: "2018 – 2024",
  gpa: "Second Class Upper Division"
};

export const certifications = [
  "Alx Udacity - Fullstack Nanodegree (Flask, SQL, Docker)",
  "Altschool Africa - Diploma in Backend Engineering (Node.js, SQL)", 
  "UNIFECS OAU – Certification in Project Management and Customer Relationship Management",
  "Alison.com - Foundation Diploma in Mathematics"
];
